import type { ThemeOptions } from '@mui/material/styles';

export const boxShadow = {
  down1: '0px 2px 5px rgba(0, 0, 0, 0.15)',
  down2: '0px 5px 10px rgba(0, 0, 0, 0.15)',
  down3: '0px 10px 15px rgba(0, 0, 0, 0.15)',
  left1: '-3px 0px 5px rgba(0, 0, 0, 0.15)',
  left2: '-5px 0px 10px rgba(0, 0, 0, 0.15)',
  left3: '-10px 0px 15px rgba(0, 0, 0, 0.15)',
  right1: '3px 0px 5px rgba(0, 0, 0, 0.15)',
  right2: '5px 0px 10px rgba(0, 0, 0, 0.15)',
  right3: '10px 0px 15px rgba(0, 0, 0, 0.15)',
  up1: '0px -3px 5px rgba(0, 0, 0, 0.15)',
  up2: '0px -5px 10px rgba(0, 0, 0, 0.15)',
  up3: '0px -10px 15px rgba(0, 0, 0, 0.15)',
};

export const shadows = [
  'none',
  'none',
  boxShadow.down2,
  boxShadow.down3,
  boxShadow.left1,
  boxShadow.left2,
  boxShadow.left3,
  boxShadow.right1,
  boxShadow.right2,
  boxShadow.right3,
  boxShadow.up1,
  boxShadow.up2,
  boxShadow.up3,
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
] as ThemeOptions['shadows'];
